const title = 'ioka fintech admin panel';

const email = 'd.yermekuly@ioka.kz';

const repository = 'https://git.ioka.kz/payment-processing/frontier/ioka-fintech-admin';

const messages = {
  app: {
    crash: {
      title: 'Oooops... Sorry, I guess, something went wrong. You can:',
      options: {
        email: `contact with author by this email - ${email}`,
        reset: 'Press here to reset the application',
      },
    },
  },
  loader: {
    fail: 'Hmmmmm, there is something wrong with this component loading process... Maybe trying later would be the best idea',
  },
  images: {
    failed: 'something went wrong during image loading :(',
  },
  404: 'Страница не найдена',
};

const dateFormat = 'MMMM DD, YYYY';

export { dateFormat, messages, repository, email, title };
